import { styled } from '@material-ui/core';
import { FormLabel } from 'components/FormTexts';

export const Body = styled('div')({
  '&>:not(:last-child)': {
    marginBottom: '18px',
  },
});

export const GroupLabel = styled(FormLabel)({
  marginBottom: '16px',
});
